import { gql } from '@apollo/client'
import { PUBLIC_PROFILE_CARD_FIELDS } from '../fragments/publicProfileCardFields'

export const GET_PUBLIC_USER_PROFILE = gql`
  ${PUBLIC_PROFILE_CARD_FIELDS}
  query GetPublicUserProfile($id: ID!) {
    publicUserProfile(id: $id) {
      ...PublicProfileCardFields
      channels {
        id
        name
        description
        viewerIsOwner
        viewerIsFollowing
      }
      careerEntries {
        id
        role
        startDate
        endDate
        details
        careerOrganization {
          id
          name
        }
      }
    }
  }
`

export const GET_CAREER_ENTRY_OVERLAPS = gql`
  ${PUBLIC_PROFILE_CARD_FIELDS}
  query GetCareerEntryOverlaps($careerEntryId: ID!, $limit: Int, $offset: Int) {
    careerEntryOverlaps(careerEntryId: $careerEntryId, limit: $limit, offset: $offset) {
      careerOrganization {
        id
        name
      }
      matches {
        profile {
          ...PublicProfileCardFields
        }
        careerEntries {
          id
          role
          startDate
          endDate
          details
          careerOrganization {
            id
            name
          }
        }
      }
      totalCount
      offset
      limit
    }
  }
`
